import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { WheelGamePage } from '@bcraft-project/frontend-lib'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { useMediaMaxTablet } from 'shared/style/var'

import { selectIsUserAuthenticated, selectUserCurrrency } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { selectLanguage } from 'features/userSettings/selectors'

import { useModalContext } from 'components/HOC/withModalQuery/ModalContext'

import '@bcraft-project/frontend-lib/dist/style.css'
import './WheelGame.scss'

export const WheelGame = () => {
  const history = useHistory()
  const isMobile = useMediaMaxTablet()
  const { pushNewModal } = useModalContext()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).wheelGame
  const userCurrency = useSelector(selectUserCurrrency, shallowEqual)
  const lang = useSelector(selectLanguage, shallowEqual)

  const notAuthCallback = () => {
    pushNewModal(MODAL_ROUTE_URLS.SIGN_IN())()
  }

  return (
    <div className="wheelwwww">
      <WheelGamePage
        actions={{
          notAuthCallback,
        }}
        data={{
          isAuth,
          locale,
          currentLanguage: lang,
          userCurrency,
        }}
      />
    </div>
  )
}
